<template>
  <v-list class="transparent">
    <!-- <v-list-item class="px-0">
    <v-list-item-content class="py-0">
      <v-list-item-subtitle
        v-if="user.tier"
        class="text-capitalize font-weight-bold white--text"
        :class="membershipClass"
        >{{ user.tier.name }} membership</v-list-item-subtitle
      >
      <v-list-item-subtitle
        class="grey--text f10"
        :class="validityClass"
        >Valid upto 31st Dec 2020</v-list-item-subtitle
      >
    </v-list-item-content>
  </v-list-item> -->
  </v-list>
</template>

<script>
export default {
  props: {
    membershipClass: {
      type: String,
      default: '',
      required: false
    },
    validityClass: {
      type: String,
      default: '',
      required: false
    }
  },
  computed: {
    user() {
      return this.$store.state.profile.data
    }
  }
}
</script>
